export const checkAcessRights = (route: string, rightID: string) => {
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }
  // userResponse
  //   ?.find((e: any) => e.MenuKey === route?.substring(1))
  //   ?.RightsID?.includes(rightID);

  // return true;
  return userResponse
    ?.find((e: any) => e.MenuKey === route?.substring(1))
    ?.RightsID?.includes(rightID);
};

export const hasRights = (MenuKey: string) => {
  const userResponseString = localStorage.getItem("UserRightsAssign") || "[]";
  let userResponse: {
    MenuID: number;
    MenuKey: string;
    MenuName: string;
    RightsID: string;
  }[];

  try {
    userResponse = JSON.parse(userResponseString);
  } catch (error) {
    userResponse = [];
  }

  const menu = userResponse.find((item) => item.MenuKey === MenuKey);
  return menu && menu.RightsID;
};

export function formatIndianNumber(number: number): string {
  if (number === null || number === undefined || isNaN(number)) return "";

  const [integerPart, decimalPart] = number.toFixed(2).split(".");

  const lastThree = integerPart.slice(-3);
  const otherNumbers = integerPart.slice(0, -3);

  const formattedOtherNumbers = otherNumbers.replace(
    /\B(?=(\d{2})+(?!\d))/g,
    ","
  );

  const formattedNumber =
    (formattedOtherNumbers ? formattedOtherNumbers + "," : "") + lastThree;

  return `${formattedNumber}.${decimalPart}`;
}

export const getRequestId = (): string => {
  const Request_Id = sessionStorage.getItem("request_id");

  if (Request_Id) {
    return Request_Id;
  } else {
    const newRequestId =
      "REQ-" +
      Date.now().toString(36) +
      "-" +
      Math.random().toString(36).substring(2, 10).toUpperCase();

    return newRequestId;
  }
};

export const calculateFareDetailsFromReprint = (
  response: any[]
  // passengerCount: PassengerCount
) => {
  const totals = {
    adults: {
      basic: 0,
      taxes: 0,
      serviceAmount: 0,
      trademarkupAmount: 0,
      total: 0,
      gst: 0,
    },
    children: {
      basic: 0,
      gst: 0,
      taxes: 0,
      serviceAmount: 0,
      trademarkupAmount: 0,
      total: 0,
    },
    infants: {
      basic: 0,
      gst: 0,
      taxes: 0,
      serviceAmount: 0,
      trademarkupAmount: 0,
      total: 0,
    },
    overall: {
      basic: 0,
      taxes: 0,
      serviceAmount: 0,
      trademarkupAmount: 0,
      total: 0,
      gst: 0,
    },
  };

  response.forEach((segment) => {
    segment.PAXTicketDetails.forEach((pax: any) => {
      pax.Fares.forEach((fare: any) => {
        fare.FareDetails.forEach((detail: any) => {
          const {
            PAX_Type,
            Basic_Amount,
            AirportTax_Amount,
            Total_Amount,
            GST,
            Trade_Markup_Amount,
            Service_Fee_Amount,
          } = detail;

          if (PAX_Type === 0) {
            totals.adults.basic += Basic_Amount;
            totals.adults.taxes += AirportTax_Amount;
            totals.adults.serviceAmount += Service_Fee_Amount;
            totals.adults.trademarkupAmount += Trade_Markup_Amount;
            totals.adults.total += Total_Amount;
            totals.adults.gst += GST;
          } else if (PAX_Type === 1) {
            totals.children.basic += Basic_Amount;
            totals.children.taxes += AirportTax_Amount;
            totals.adults.serviceAmount += Service_Fee_Amount;
            totals.adults.trademarkupAmount += Trade_Markup_Amount;
            totals.children.total += Total_Amount;
            totals.children.gst += GST;
          } else if (PAX_Type === 2) {
            totals.infants.basic += Basic_Amount;
            totals.infants.taxes += AirportTax_Amount;
            totals.adults.serviceAmount += Service_Fee_Amount;
            totals.adults.trademarkupAmount += Trade_Markup_Amount;
            totals.infants.total += Total_Amount;
            totals.infants.gst += GST;
          }
        });
      });
    });
  });

  // Calculate overall totals
  totals.overall.basic =
    totals.adults.basic + totals.children.basic + totals.infants.basic;
  totals.overall.taxes =
    totals.adults.taxes + totals.children.taxes + totals.infants.taxes;
  totals.overall.serviceAmount =
    totals.adults.serviceAmount +
    totals.children.serviceAmount +
    totals.infants.serviceAmount;
  totals.overall.trademarkupAmount =
    totals.adults.trademarkupAmount +
    totals.children.trademarkupAmount +
    totals.infants.trademarkupAmount;
  totals.overall.gst =
    totals.adults.gst + totals.children.gst + totals.infants.gst;
  totals.overall.total =
    totals.adults.total + totals.children.total + totals.infants.total;

  return totals;
};

// export const getFlightImage = (flightName: string) => {
//   const flight = flightImages?.find((f: any) => f.name === flightName);
//   return flight?.image || DEFAULT_FLIGHT;
//   // return `https://static.tripjack.com/img/airlineLogo/v1/${flightCode}.png`;
// };

export const getFlightImage = (flightCode: string) => {
  return `https://images.skyruner.com/Uploads/AirlineLogo/${flightCode}.png`;
};

export const addCancellationCharge = (
  paxes: any[],
  cancellationCharge: number,
  cancellationChargeGSTPer: number
) => {
  const nameFrequency: Record<string, number> = {};

  // Count how many times each passenger name occurs
  for (const pax of paxes) {
    const name = pax.passanger_name;
    if (name) {
      nameFrequency[name] = (nameFrequency[name] || 0) + 1;
    }
  }

  // Apply cancellation charges
  return paxes.map((pax) => {
    const name = pax.passanger_name;
    const isRepeated = nameFrequency[name] > 1;

    // Skip charge if paxType is 2
    if (pax.paxType === 2) return { ...pax };

    return {
      ...pax,
      cancellation_charge: isRepeated
        ? cancellationCharge / 2
        : cancellationCharge,
      cancellation_gst_per: cancellationChargeGSTPer,
    };
  });
};
